module.exports = __webpack_public_path__ + "img/zzt-fp.b80ac38f.png";